<div *ngIf="vademecum">
  <a [href]="pdfVademecumUrl" download="Vademecum {{booking.student.firstName}} {{booking.student.lastName}}">Download PDF</a>
<br>
  <a routerLink="/management/edit-vademecum/{{booking.id}}" *ngIf="userService.hasAnyRole(['admin', 'editor'])">Update vademecum info</a>
</div>

